module.exports = __webpack_public_path__ + "img/122.6.54e2748a.png";